import { useLucideContext } from 'lucide-react';
import * as React from 'react';

export type CustomIconProperties = {
	color?: string,
	style?: React.CSSProperties
	size?: string | number
	width?: string | number
	height?: string | number
	fill?: string
};

function customIconWrapper<AdditionalProps = object>(svgChildren: React.ReactNode | ((props: AdditionalProps) => React.ReactNode), options?: { viewBox?: string }) {
	return function CustomIcon(props: CustomIconProperties & AdditionalProps) {
		const context = useLucideContext();
		const size = props.size ?? context.size;

		return <svg style={props.style} width={props.width ?? size} height={props.height ?? size} viewBox={options?.viewBox ?? '0 0 24 24'} fill={props.fill ?? 'none'} xmlns="http://www.w3.org/2000/svg" color={props.color ?? context.color}>
			{typeof svgChildren === 'function' ? svgChildren(props) : svgChildren}
		</svg>;
	};
}

export default customIconWrapper;
